module.exports = __webpack_public_path__ + "static/img/11.5723ae6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/3/1/zh/11.png
// module id = 3vF5
// module chunks = 0